// extracted by mini-css-extract-plugin
export var container = "_fz-1";
export var cornerButtonContainer = "_fz-6";
export var disabled = "_fz-2";
export var dragActive = "_fz-3";
export var fileContainer = "_fz-5";
export var hiddenInput = "_fz-4";
export var widthContainer = "_fz-0";